import { LABOR_COST_CALCULATOR_TYPE } from '../../constants';
import { SUBSCRIPTION_LEVELS } from '../../account/constants';

export default function OrgSettings(
  Restangular,
  Authentication,
  PersonaCollection,
  Utils,
  toTimeFilter,
  dateFilter
) {
  'ngInject';

  function _handleTemplateLocations(template) {
    if (template.locations?.length) {
      const existingLocations = template.locations.filter(
        (loc) => PersonaCollection.personasDict[loc.id]
      );
      if (!existingLocations.length) {
        template.deleted = true;
      }

      template.locationLabel = Utils.addJoin(
        existingLocations.map((loc) => PersonaCollection.personasDict[loc.id].name)
      );
    } else {
      template.locationLabel = 'All locations';
    }
  }

  Restangular.extendModel('account/org/settings', (settings) => {
    if ('shiftTemplates' in settings) {
      settings.shiftTemplates.forEach((template) => {
        template.deleted = false;
        if (template.start) {
          template.dtstart = Utils.getRealDate(`2016-01-01T${template.start}`);
        } else {
          template.deleted = true;
        }

        if (template.end) {
          template.dtend = Utils.getRealDate(`2016-01-01T${template.end}`);
          if (template.dtstart && template.dtstart > template.dtend) {
            template.dtend = Utils.addDays(template.dtend, 1);
          }
        } else {
          template.deleted = true;
        }

        template.duration = (template.dtend - template.dtstart) / 1000 / 60 / 60;
        if (template.duration === 0) {
          template.durationLabel = '24 hours';
        } else {
          template.durationLabel = `${Math.round(template.duration * 10) / 10} hours`;
        }

        template.time = `${toTimeFilter(template.dtstart)} - ${toTimeFilter(template.dtend)}`;

        _handleTemplateLocations(template);

        if (template.breakDuration) {
          template.breakLabel = `${template.breakDuration} minutes`;
        } else {
          template.breakLabel = 'No break';
        }

        if (Authentication.user.orgSettings.shiftBreakType) {
          if (template.breakDuration) {
            template.timeAux = `${template.breakDuration}min break`;
          } else {
            template.timeAux = `${template.breakLabel}`;
          }
        }
      });
    }

    if (typeof settings.overtimeWeekMultiplier === 'string') {
      settings.overtimeWeekMultiplier = Number(settings.overtimeWeekMultiplier.replace(',', '.'));
    }

    if (typeof settings.spreadOfHoursPay === 'string') {
      settings.spreadOfHoursPay = Number(settings.spreadOfHoursPay.replace(',', '.'));
    }

    ['payrollPeriodStartDate', 'payrollPeriodStartDateTwo'].forEach((dateKey) => {
      if (typeof settings[dateKey] === 'string') {
        settings[dateKey] = Utils.getRealDate(settings[dateKey]);
      }
    });

    if (settings.firstDayOfWeek === 7) {
      settings.firstDayOfWeek = 0;
    }

    if (!('laborCostCalculatorType' in settings)) {
      settings.laborCostCalculatorType = LABOR_COST_CALCULATOR_TYPE.US;
    }

    // fallback to work with older server
    if (!('premiumTrialLength' in settings)) {
      settings.premiumTrialLength = 30;
    }

    if (settings.laborCostCalculatorType === LABOR_COST_CALCULATOR_TYPE.ICELAND) {
      /**
       * Server should marshal it as true but we can't make this change there without breaking
       * compatibility with current clients. So we need this hack first and then when server
       * marshalls it as true we can remove this if.
       */
      settings.holidaysEnabled = true;
    }

    if (settings.premiumFeatures) {
      settings.premiumFeatures.shiftsBulkEdit = SUBSCRIPTION_LEVELS.PREMIUM;
    }

    return settings;
  });

  Restangular.addRequestInterceptor((element, operation, what) => {
    if (
      element &&
      'shiftTemplates' in element &&
      what === 'account/org/settings' &&
      (operation === 'post' || operation === 'put')
    ) {
      element.shiftTemplates = element.shiftTemplates
        .filter((template) => !template.deleted)
        .map((template) => ({
          start: dateFilter(template.dtstart, 'HH:mm'),
          end: dateFilter(template.dtend, 'HH:mm'),
          openEnd: template.openEnd,
          locations: template.locations?.map(({ id }) => ({ id })),
          breakDuration: template.breakDuration,
        }));
    }

    return element;
  });

  return Restangular.service('account/org/settings');
}
